function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import isNull from 'lodash/isNull';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import { AppContext } from 'context';
import Avatar from 'components/Avatar';
import Button from 'components/Form/Button';
import Account from 'modules/Account';
import * as actions from '../../actions';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './ClinicClearData.pcss';
var _React_PureComponent;
class ClinicClearData extends (_React_PureComponent = React.PureComponent) {
    static getDerivedStateFromProps(props, state) {
        const { isInProgress } = props;
        if (state.isPausing && !isInProgress) {
            return {
                isPausing: false
            };
        }
        return null;
    }
    componentDidUpdate(prevProps) {
        const { isInProgress } = this.props;
        if (prevProps.isInProgress !== isInProgress && !isInProgress) {
            window.removeEventListener('beforeunload', this.onUnload);
        }
    }
    componentWillUnmount() {
        const { patientsCount, isInProgress, hasErrors } = this.props;
        if (this.props.isInProgress) {
            this.onPause();
        }
        if (patientsCount === 0 && !isInProgress && !hasErrors) {
            this.props.onFetchClinicMemberships();
        }
    }
    onRemoveData() {
        const profilesReferenceKey = get(this.props.activeClinicMembership, 'clinic.profilesReferenceKey');
        if (process.env.BROWSER && profilesReferenceKey) {
            this.props.onRemoveData(this.props.activeClinicMembership);
            window.addEventListener('beforeunload', this.onUnload);
        }
    }
    onPause() {
        this.setState({
            isPausing: true
        });
        this.props.onPause();
        window.removeEventListener('beforeunload', this.onUnload);
    }
    onUnload(evt) {
        evt.preventDefault();
        evt.returnValue = '';
    }
    renderLogo(clinic) {
        const { logo, name } = clinic;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.avatar,
            children: /*#__PURE__*/ _jsx(Avatar, {
                avatarImg: logo,
                name: name,
                className: styles.avatar__imgWrapper,
                imgClassName: styles.avatar__img,
                initialsClassName: styles.avatar__initials
            })
        });
    }
    renderAction() {
        const { patientsCount, isInProgress } = this.props;
        const profilesReferenceKey = get(this.props.activeClinicMembership, 'clinic.profilesReferenceKey');
        return /*#__PURE__*/ _jsx(Button, {
            styleModifier: "primary",
            labelMessage: messages.buttons[isInProgress ? 'pause' : 'start'],
            className: "btn--filled px-4",
            isDisabled: !profilesReferenceKey || patientsCount === 0,
            isInProgress: this.state.isPausing,
            onClick: ()=>isInProgress ? this.onPause() : this.onRemoveData()
        });
    }
    renderRow(labelMessage, value, isActive = false) {
        return /*#__PURE__*/ _jsxs("div", {
            className: `row justify-content-between my-4 ${!isActive && 'text--muted'}`,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, labelMessage))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto text-right",
                    children: value
                })
            ]
        });
    }
    render() {
        const { clinic } = this.props.activeClinicMembership;
        const { patientsCount, isInProgress, hasErrors } = this.props;
        const b = (chunk)=>/*#__PURE__*/ _jsx("b", {
                children: chunk
            });
        return /*#__PURE__*/ _jsx("div", {
            className: styles.container,
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.containerInner,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "content",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.root,
                        children: [
                            this.renderLogo(clinic),
                            /*#__PURE__*/ _jsx("p", {
                                className: styles.clinicName,
                                children: clinic.name
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: styles.info,
                                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.removeClinicData), {
                                    values: {
                                        b
                                    }
                                }))
                            }),
                            this.renderAction(),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.steps,
                                children: [
                                    this.renderRow(messages.labels.searchingForPatients, !isNull(patientsCount) && 'Done', isInProgress || !isNull(patientsCount)),
                                    this.renderRow(messages.labels.removingPatients, patientsCount === 0 ? 'Done' : patientsCount, !isNull(patientsCount)),
                                    this.renderRow(messages.labels.clearingClinicData, patientsCount === 0 && !isInProgress && !hasErrors && 'Done', patientsCount === 0)
                                ]
                            })
                        ]
                    })
                })
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            isPausing: false
        };
    }
}
_define_property(ClinicClearData, "contextType", AppContext);
_define_property(ClinicClearData, "propTypes", {
    // Explicit props
    activeClinicMembership: Account.shapes.clinicMembership,
    // Implicit props
    patientsCount: PropTypes.number,
    isInProgress: PropTypes.bool,
    hasErrors: PropTypes.bool,
    // Implicit actions
    onRemoveData: PropTypes.func,
    onPause: PropTypes.func,
    onFetchClinicMemberships: PropTypes.func
});
const mapStateToProps = (state)=>({
        patientsCount: selectors.patientsCount(state),
        isInProgress: selectors.isRemoveClinicDataInProgress(state),
        hasErrors: selectors.hasRemoveClinicDataErrors(state),
        activeClinicMembership: Account.selectors.activeClinicMembership(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onRemoveData: (clinicMembership)=>dispatch(actions.removeClinicData(clinicMembership)),
        onPause: ()=>dispatch(actions.removeClinicDataPause()),
        onFetchClinicMemberships: ()=>dispatch(Account.actions.fetchMemberships())
    });
const ConnectedClinicClearData = connect(mapStateToProps, mapDispatchToProps)(ClinicClearData);
export default withStyles(styles)(ConnectedClinicClearData);
